<div *ngIf="roomType && room">
    <div class="grid grid-cols-1 lg:grid-cols-2 lg:gap-7 bg-white">
        <div class="h-full">
            <!-- right content -->
            <!-- <p-carousel [value]="getRoomTypeImages()" [showNavigators]="false" [numVisible]="1" [numScroll]="1"
                [circular]="false" class="h-full">
                <ng-template let-img pTemplate="item">
                    <div class="h-[280px] lg:h-[512px] rounded bg-no-repeat bg-center bg-cover"
                        [style.background-image]="'url(' + img+ ')'">

                    </div>
                </ng-template>
            </p-carousel> -->
            <app-xn-carousel
                *ngIf="visible"
                [images]="getRoomTypeImages()"
            ></app-xn-carousel>
        </div>
        <div class="">
            <div class="mr-0 lg:hidden" *ngIf="roomType.matterPortRoomType && roomType.matterPortRoomType.description">
                <div class="roomTypeHTMLDesc" [innerHtml]="roomType.matterPortRoomType.description"></div>
                <div class="roomTypeHTMLDesc" *ngIf="room.floorPlanImage" (click)="showFloorPlan()">
                    <span class="material-symbols-outlined text-medgrey cursor-pointer text-[20px]">map</span>
                    <span class="ml-2 text-medgrey cursor-pointer">Floor Plan</span>
                </div>
            </div>
            <div class="mt-2 lg:mt-0 flex justify-between items-center">
                <div class="text-[16px] lg:text-[18px] font-medium">Apartment number {{room.roomNumber}}</div>
                <div class="hidden mr-0 lg:flex lg:justify-end flex-col"
                    *ngIf="roomType.matterPortRoomType && roomType.matterPortRoomType.description">
                    <div class="roomTypeHTMLDesc" [innerHtml]="roomType.matterPortRoomType.description"></div>
                    
                </div>
            </div>
            <div class="text-[20px] lg:text-[24px] font-NewSpirit block mt-3">{{roomType.roomTypeName}}</div>
            <div class="mt-3 flex flex-wrap">
                <span class="mr-6 mb-2  lg:mr-6 whitespace-nowrap">
                    <span class="material-symbols-outlined">bed</span>
                    <span class="ml-4">{{roomType.numberOfBedrooms}}</span>
                </span>
                <span class="mr-6 mb-2  lg:mr-6 whitespace-nowrap">
                    <span class="material-symbols-outlined ">shower</span>
                    <span class="ml-4">{{roomType.numberOfBathrooms}}</span>
                </span>
                <span class="mr-6 mb-2  lg:mr-6" *ngIf="room.aspectItem && room.aspectItem.length">
                    <span class="material-symbols-outlined">explore</span>
                    <span class="ml-4">{{getAspectToString(room.aspectItem)}}</span>
                </span>
                <span class="mt-[0.5px] mr-6 mb-2 lg:mr-6" *ngIf="room.furnishedItem && room.furnishedItem.length">
                    <span class="mt-[2px]">{{room.furnishedItem[0].amenityName}}</span>
                </span>
                <span class="mt-[0.5px] mb-2 lg:mr-8">
                    <span class="whitespace-nowrap">{{room.minRatePlan.roomRate.amount | currency: room.minRatePlan.currencyCode : 'symbol-narrow'}} <span
                        class="inline-block">/{{getRateType(room.minRatePlan.roomRate.rateType)}}</span></span>
                </span>
            </div>
            <div class="mt-6 text-[14px] lg:text-[16px] font-medium" *ngIf="room && room.amenities && room.amenities.length">{{'apartment-features' | translate}}</div>
            <div class="pl-0 lg:pl-[18px] mt-4" *ngIf="room && room.amenities && room.amenities.length">
                <div class="grid grid-cols-2 gap-x-7 gap-y-3">
                    <!-- <div *ngFor="let amenity of room.amenities;index as i" class="w-5 lg:w-8 max-w-[64px] mb-3 text-body-small text-grey-1 flex items-center">
                        <span class=" text-nero max-h-[64px] max-w-[64px] inline-block mr-2"><img *ngIf="amenity.mediaItem" class="w-8 max-w-[64px] inline-block mr-2"
                                [src]="amenity.mediaItem.contentFilename" [alt]="amenity.amenityName">
                                <img *ngIf="!amenity.mediaItem"
                                class="w-5 lg:w-8 max-w-[64px] inline-block mr-2" src="assets/images/default_amenity_icon.svg" [alt]="amenity.amenityName">
                            </span>
                        {{amenity.amenityName}}
                    </div> -->
                    <div *ngFor="let amenity of room.amenities;index as i" class="h-[48px] lg:h-[64px] text-body-small text-[12px] lg:text-[14px] text-grey-1 flex items-center"
                    [class.hidden]="!roomType.expandAmenities && i >= totalDisplayAmenities">
                    <span class=" text-nero max-w-[64px] max-h-[64px] inline-block mr-4"><img *ngIf="amenity.mediaItem"
                        class="w-5 lg:w-8 max-w-[64px] inline-block mr-2" [src]="amenity.mediaItem.contentFilename" [alt]="amenity.amenityName">
                        <img *ngIf="!amenity.mediaItem"
                        class="w-5 lg:w-8 max-w-[64px] inline-block mr-2" src="assets/images/default_amenity_icon.png" [alt]="amenity.amenityName"></span>
                    {{amenity.amenityName}}
                  </div>
                </div>
            </div>
            <!-- <div class="mt-6 text-[16px] text-medgrey font-bold" *ngIf="room && room.roomLongDescription">{{'apartment-details' | translate}}</div> -->
            <div class="mt-2 text-[14px] lg:text-[16px]" *ngIf="room && room.roomLongDescription" [innerHtml]="room.roomLongDescription"></div>

            <div class="mt-6 text-[14px] lg:text-[16px] font-medium" *ngIf="room && room.householdDetail">{{'Household Description' | translate}}</div>
            <div class="mt-2 text-[14px] lg:text-[16px]" *ngIf="room && room.householdDetail" [innerHtml]="getHouseHoldDescription(room.householdDetail)"></div>

            <div class="mt-8">
                <button class="w-full lg:w-auto btn btn-outline mt-2 lg:mt-0 mr-2" *ngIf="room.floorPlanImage"
                (click)="showFloorPlan()" >{{'button.label.view-floor-plan' | translate}}</button>
                <button class="w-full lg:w-auto btn btn-primary mt-2 lg:mt-0"
                (click)="bookAnInspection()" >{{'button.label.book-a-tour' | translate}}</button>
            </div>
            <!-- <div class="mt-6 text-[14px] text-medgrey font-bold">Rate plan</div>
            <div *ngFor="let ratePlan of room.ratePlans" class="mt-6">
                <div class="text-[1.2em]">
                    <span class="material-symbols-outlined">task_alt</span> {{ratePlan.ratePlanName}}
                    ({{ratePlan.currencyCode}} {{ratePlan.roomRate.amount | money}}
                    /{{ratePlan.roomRate.rateType}} Rent)
                </div>
            </div> -->
        </div>
    </div>
</div>